/**
 * Maths on screen (#362). Only TeX that came from the server's kernel (`tex` fields, `statementTex`) or from
 * `previewTexOfAnswer` is rendered here - never the learner's raw text as TeX.
 *
 * `katex.render` builds DOM nodes and sets styles through the CSSOM, so it works under the server's
 * `style-src 'self'`; `renderToString` would emit inline `style=""` attributes that the policy blocks.
 * The wrapper is always `dir="ltr"`: maths stays left to right inside a Hebrew page.
 */

import { useEffect, useRef } from 'react';
import katex from 'katex';

export function Tex({ tex, display = false }: { readonly tex: string; readonly display?: boolean }): React.JSX.Element {
  const ref = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    if (ref.current === null) return;
    katex.render(tex, ref.current, { trust: false, throwOnError: false, displayMode: display, strict: 'ignore' });
  }, [tex, display]);
  return <span ref={ref} dir="ltr" className={display ? 'tex tex-display' : 'tex'} />;
}
